import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

export default function Dashboard() {
  const [stats, setStats] = useState({ total: 0, active: 0, interns: 0, departments: 0 });
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    api.get('/employees').then(r => {
      const emps = r.data.data;
      const depts = new Set(emps.map(e => e.department).filter(Boolean));
      setStats({
        total: emps.length,
        active: emps.filter(e => e.status === 'Active').length,
        interns: emps.filter(e => e.employment_type === 'Intern').length,
        departments: depts.size,
      });
      setRecent(emps.slice(0, 6));
    }).catch(() => {});
  }, []);

  const STATS = [
    { label: 'Total Employees', val: stats.total, bg: '#eef2ff', color: '#4f46e5', icon: <svg fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/></svg> },
    { label: 'Active Staff', val: stats.active, bg: '#d1fae5', color: '#059669', icon: <svg fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg> },
    { label: 'Interns', val: stats.interns, bg: '#fef3c7', color: '#d97706', icon: <svg fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/></svg> },
    { label: 'Departments', val: stats.departments, bg: '#ede9fe', color: '#7c3aed', icon: <svg fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24"><path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/></svg> },
  ];

  const initials = e => `${e.first_name?.[0] || ''}${e.last_name?.[0] || ''}`.toUpperCase();
  const statusBadge = s => s === 'Active' ? 'badge-green' : s === 'Inactive' ? 'badge-amber' : 'badge-red';

  return (
    <div>
      <div className="stats-row">
        {STATS.map(s => (
          <div key={s.label} className="stat-card">
            <div className="stat-icon" style={{ background: s.bg }}><svg style={{ color: s.color }} fill="none" stroke={s.color} strokeWidth={1.8} viewBox="0 0 24 24">{s.icon.props.children}</svg></div>
            <div><div className="stat-num">{s.val}</div><div className="stat-lbl">{s.label}</div></div>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-header">
          <span className="card-title">Recent Employees</span>
          <Link to="/employees" className="btn btn-outline btn-sm">View All</Link>
        </div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Employee</th><th>ID</th><th>Designation</th><th>Department</th><th>Type</th><th>Status</th><th></th></tr></thead>
            <tbody>
              {recent.map(e => (
                <tr key={e.id}>
                  <td><div className="emp-name-cell"><div className="emp-avatar">{initials(e)}</div><div><div style={{fontWeight:600}}>{e.first_name} {e.last_name}</div><div style={{fontSize:11,color:'var(--slate-500)'}}>{e.email}</div></div></div></td>
                  <td><span className="badge badge-slate">{e.employee_id}</span></td>
                  <td>{e.current_designation || '—'}</td>
                  <td>{e.department || '—'}</td>
                  <td>{e.employment_type ? <span className="badge badge-indigo">{e.employment_type}</span> : '—'}</td>
                  <td><span className={`badge ${statusBadge(e.status)}`}>{e.status}</span></td>
                  <td><Link to={`/employees/${e.id}`} className="btn btn-outline btn-sm">View</Link></td>
                </tr>
              ))}
              {recent.length === 0 && <tr><td colSpan={7}><div className="empty-state"><p>No employees yet. <Link to="/employees/new">Add one</Link>.</p></div></td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
